import PropTypes from "prop-types";

const HowToBlog = ({title, content}) => {

  return (
    <div className="how-to-blog__block">
      <h2 className="how-to-blog__title-block">{title}</h2>
      <div className="how-to-blog__block"
           dangerouslySetInnerHTML={{__html: content.join("")}}>
      </div>
    </div>
  );
};

HowToBlog.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
};

export default HowToBlog;
